import { Button, Form, Input, Popconfirm, Row, Menu, Alert, Col } from "antd";
import { Navigate, useNavigate } from 'react-router-dom';
import React, { useState } from "react";
import { HomeView } from "../HomeView";
import {openNotification} from "@seims/shared";

import api from "../../services/usersService";
import util from "../../utils/functions/custom";

import { Messages, Notify } from "../../services/custom/Messages";
import { recordError } from "../../utils/logService";

export const UserChangePassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  let path = `/`;

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 12,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 12,
      },
      sm: {
        span: 8,
      },
    },
  };

  const cancel = () => {
    navigate(path);
  };

  const onFinish = async (values) => {
    try {
      const { password } = values;
      
      const request = await api.updateUserPassword(password);

      var msg;

      if (request.status === 200 || request.status === 201) {

        form.resetFields("");
        msg = util.parseMessage(
          Messages.UPDATE_SUCCESSWITHOK,
          "User password"
        );
        openNotification("Updating Password", msg, Notify.SUCCESS);

        return;
      }

      msg = util.parseMessage(
        Messages.UPDATE_FAILURE,
        "User password"
      );
      openNotification("Updating Password", msg, Notify.ERROR);
    } catch (error) {

      openNotification(
        "Updating Password",
        "SYSTEM FAILED TO UPDATE",
        Notify.ERROR
      );
      recordError(error);

    }
  };

  const passwordRegEx = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  const Passwordmessages =
    "Password must be at least 8 characters long, have 1 number,1 uppercase, and 1 special character";


  return (
    <div className="content">
      <Col xs={24}>
        <h1 className="center-align">Update Password</h1>
      </Col>
      <Form
        {...formItemLayout}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
      >
        {/* <Form.Item
          name="currentpassword"
          label="Current Password"
          rules={[
            {
              required: true,
              message: "Please input your current password!",
            },
          ]}
          hasFeedback
        >
          <Input.Password />
        </Form.Item> */}

        <Form.Item
          name="password"
          label="New Password"
          rules={[
            {
              required: true,
              message: Passwordmessages,
              pattern: passwordRegEx,
            },
          ]}
          hasFeedback
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          dependencies={["password"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: Passwordmessages,
              pattern: passwordRegEx,
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (
                  !value ||
                  getFieldValue("password") === value
                ) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  new Error(
                    "The two passwords that you entered do not match!"
                  )
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
        {/* <div style={{ display: "flex", justifyContent: "flex-end" }}> */}
        <Row>
          <Col xs={24} className="center-align">
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            <Popconfirm
              title="Are you sure you want to cancel...you will lose all info entered?"
              onConfirm={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button type="default" style={{ marginLeft: 10 }}>
                Cancel
              </Button>
            </Popconfirm>
          </Col>
        </Row>
        {/* </div> */}

      </Form>
    </div>
  );
};
